/**
 * @generated SignedSource<<67b252db963d68daad7a263668417c85>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EventChargeStaffControl = "ADMIN_ONLY" | "SELECTABLE";
export type EventMemberControl = "HIDDEN" | "SELECTABLE" | "VISIBLE";
export type RegistrationChargeSelectionRowQuery$variables = {
  clientId?: string | null | undefined;
  eventId: string;
  hasSavedRegistration: boolean;
  registrationId: string;
};
export type RegistrationChargeSelectionRowQuery$data = {
  readonly node: {
    readonly __typename: "Event";
    readonly clientEligibleSignUpWindows: ReadonlyArray<{
      readonly charges: {
        readonly edges: ReadonlyArray<{
          readonly memberControl: EventMemberControl;
          readonly node: {
            readonly chargeRuleSet: {
              readonly chargeRules: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly price: number;
                  } | null | undefined;
                } | null | undefined> | null | undefined;
              } | null | undefined;
              readonly displayName: string | null | undefined;
            };
            readonly id: string;
          } | null | undefined;
          readonly staffControl: EventChargeStaffControl;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly index: number;
    } | null | undefined> | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly registration?: {
    readonly id?: string;
    readonly primaryChargeType?: {
      readonly chargeRuleSet: {
        readonly chargeRules: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly price: number;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly displayName: string | null | undefined;
      };
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type RegistrationChargeSelectionRowQuery = {
  response: RegistrationChargeSelectionRowQuery$data;
  variables: RegistrationChargeSelectionRowQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "clientId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasSavedRegistration"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "registrationId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "registrationId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v8 = [
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ChargeRuleSet",
    "kind": "LinkedField",
    "name": "chargeRuleSet",
    "plural": false,
    "selections": [
      (v6/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ChargeRuleConnection",
        "kind": "LinkedField",
        "name": "chargeRules",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ChargeRuleEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ChargeRule",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v9 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "eventId"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = [
  {
    "kind": "Variable",
    "name": "clientId",
    "variableName": "clientId"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "index",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberControl",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "staffControl",
  "storageKey": null
},
v15 = [
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ChargeRuleSet",
    "kind": "LinkedField",
    "name": "chargeRuleSet",
    "plural": false,
    "selections": [
      (v6/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ChargeRuleConnection",
        "kind": "LinkedField",
        "name": "chargeRules",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ChargeRuleEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ChargeRule",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v5/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RegistrationChargeSelectionRowQuery",
    "selections": [
      {
        "condition": "hasSavedRegistration",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "registration",
            "args": (v4/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventRegistrationChargeType",
                    "kind": "LinkedField",
                    "name": "primaryChargeType",
                    "plural": false,
                    "selections": (v8/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "EventRegistration",
                "abstractKey": "__isEventRegistration"
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "EventSignUpWindow",
                "kind": "LinkedField",
                "name": "clientEligibleSignUpWindows",
                "plural": true,
                "selections": [
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventSignUpWindowChargesConnection",
                    "kind": "LinkedField",
                    "name": "charges",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventSignUpWindowChargesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventRegistrationChargeType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Event",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "RegistrationChargeSelectionRowQuery",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "EventSignUpWindow",
                "kind": "LinkedField",
                "name": "clientEligibleSignUpWindows",
                "plural": true,
                "selections": [
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventSignUpWindowChargesConnection",
                    "kind": "LinkedField",
                    "name": "charges",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventSignUpWindowChargesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventRegistrationChargeType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v15/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Event",
            "abstractKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "condition": "hasSavedRegistration",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "registration",
            "args": (v4/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventRegistrationChargeType",
                    "kind": "LinkedField",
                    "name": "primaryChargeType",
                    "plural": false,
                    "selections": (v15/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "EventRegistration",
                "abstractKey": "__isEventRegistration"
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "0c7a516185cec4962429b60f6c37209b",
    "id": null,
    "metadata": {},
    "name": "RegistrationChargeSelectionRowQuery",
    "operationKind": "query",
    "text": "query RegistrationChargeSelectionRowQuery(\n  $eventId: ID!\n  $clientId: ID\n  $registrationId: ID!\n  $hasSavedRegistration: Boolean!\n) {\n  registration: node(id: $registrationId) @include(if: $hasSavedRegistration) {\n    __typename\n    ... on EventRegistration {\n      __isEventRegistration: __typename\n      id\n      primaryChargeType {\n        id\n        chargeRuleSet {\n          displayName\n          chargeRules {\n            edges {\n              node {\n                price\n                id\n              }\n            }\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n  node(id: $eventId) {\n    __typename\n    ... on Event {\n      clientEligibleSignUpWindows(clientId: $clientId) {\n        index\n        charges {\n          edges {\n            memberControl\n            staffControl\n            node {\n              id\n              chargeRuleSet {\n                displayName\n                chargeRules {\n                  edges {\n                    node {\n                      price\n                      id\n                    }\n                  }\n                }\n                id\n              }\n            }\n          }\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "701f0447aa31797ff72fad22862cd9bd";

export default node;
